import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { HospitalFill, PeopleFill } from "react-bootstrap-icons";
import { Link } from "react-router-dom"; 

function Tiles() {
  const handleClick = (isIP) => {
    if (isIP) {
      alert("Please contact support for Inpatient services at support@diabrainai.com");
    }
  };

  const tileData = [
    { id: 1, icon: <PeopleFill size={50} color="#28a745"/>, label: "OP", link: "/home", isIP: false },
    { id: 2, icon: <HospitalFill size={50} color="#df5f56" />, label: "IP", link: "#", isIP: true },
  ];

  return (
    <Container className="mt-4 d-flex justify-content-center">
      <Row className="g-4 justify-content-center">
        {tileData.map((tile) => (
          <Col key={tile.id} xs={10} sm={6} md={4} lg={6} className="d-flex justify-content-center">
            <Card 
              className="tile-card text-center shadow-sm p-4 grid-item"
              style={{ width: "250px", cursor:"pointer" }}
              onClick={() => handleClick(tile.isIP)}
            >
              {tile.isIP ? (
                // IP: Show alert only (No navigation)
                <div className="tile-icon">
                  {tile.icon}
                  <Card.Body>
                    <Card.Title className="tile-label" style={{ fontSize: "20px", fontWeight: "bold", color: "#007bff" }}>
                      {tile.label}
                    </Card.Title>
                  </Card.Body>
                </div>
              ) : (
                // OP: Navigates to /home
                <Link to={tile.link} className="tile-icon" style={{ textDecoration: 'none' }}>
                  {tile.icon}
                  <Card.Body>
                    <Card.Title className="tile-label" style={{ fontSize: "20px", fontWeight: "bold", color: "#007bff" }}>
                      {tile.label}
                    </Card.Title>
                  </Card.Body>
                </Link>
              )}
            </Card> 
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default Tiles;
